import React from "react";
import { defineMessages } from "react-intl";
import { LocalizedText } from "../../../components/i18n/LocalizedText.js";
import { Select } from "../../../components/select/Select.js";
import { SelectStyle } from "../../../components/select/types.js";
import "@mui/material";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/select/selectStyle.js";
import "../../../components/select/MultiSelectFooter.js";
import "../../../components/select/MultiSelect.js";
import "../../../components/select/MultiSelectItem.js";
import "../../../components/select/SelectArrowIcon.js";
import "../../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../../components/select/SingleSelect.js";
import "../../../components/select/MultiSelectWithExclude.js";
import "../../../components/select/MultiSelectTextCounterWithTooltip.js";
import { TransactionType } from "../../../contract/pam.js";
const localized = defineMessages({
  p2pCredit: {
    id: "P2PTransferDirection_p2pCredit",
    defaultMessage: "Credit"
  },
  p2pDebit: {
    id: "P2PTransferDirection_p2pDebit",
    defaultMessage: "Debit"
  }
});
function renderP2PTransferDirectionEditableCell(params) {
  const types = [TransactionType.P2PTransferCredit, TransactionType.P2PTransferDebit];
  const selectOptions = types.map((t) => ({
    label: t === TransactionType.P2PTransferDebit ? localized.p2pDebit : localized.p2pCredit,
    value: t
  }));
  function handleChange(value) {
    const editValue = { id: params.id, value: value?.[0], field: params.field };
    if (params.cellMode === "view") {
      params.api.startCellEditMode({ id: params.id, field: params.field });
    }
    params.api.setEditCellValue(editValue);
  }
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      options: selectOptions,
      value: params.value ?? TransactionType.Credit,
      onSubmit: handleChange,
      selectStyle: SelectStyle.Default
    }
  );
}
function renderP2PTransferDirection(params) {
  const label = params.value === TransactionType.P2PTransferDebit ? localized.p2pDebit : localized.p2pCredit;
  return /* @__PURE__ */ React.createElement(LocalizedText, { label });
}
export {
  renderP2PTransferDirection,
  renderP2PTransferDirectionEditableCell
};
//# sourceMappingURL=TypeCell.js.map
